import React from 'react';

export interface MapExpertAvatarPinProps {
  /** URL absolue ou résolue pour l’API Maps */
  src: string;
  alt: string;
}

/**
 * Contenu visuel commun aux marqueurs Google (AdvancedMarker) : pastille avatar 40px.
 * Utilisé sur la home (couverture) et la carte des experts.
 */
export const MapExpertAvatarPin: React.FC<MapExpertAvatarPinProps> = ({ src, alt }) => (
  <div className="flex h-10 w-10 -translate-y-[10px] items-center justify-center overflow-hidden rounded-full shadow-[0_2px_10px_rgba(0,0,0,0.25)]">
    <img src={src} alt={alt} className="h-10 w-10 object-cover" />
  </div>
);
